export const multipleActionToastPreset = {
    name: 'mwMultipleActions',
    methods: [
        'textContent',
        'action',
        'theme',
        'parent'
    ],

    options: () => {
        'ngInject';
        return {
            hideDelay: 0,
            position: 'bottom left'
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/toast/presets/multiple-action.toast.preset.ts